<template>
    <Teleport to="body">
        <div v-if="visible" class="modal fade show d-block" tabindex="-1" @click.self="deny">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button type="button" class="btn-close" @click="deny"></button>
                    </div>
                    <div class="modal-body" v-html="message"></div>
                    <div class="modal-footer" v-if="mode === 'confirm'">
                        <button type="button" class="button button--primary" @click="deny">{{ noText }}</button>
                        <button type="button" class="button button--primary" @click="accept">{{ yesText }}</button>
                    </div>
                    <div class="modal-footer" v-else>
                        <button type="button" class="button button--primary" @click="accept">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="visible" class="modal-backdrop fade show"></div>
    </Teleport>
</template>

<script setup>
import {ref} from 'vue';

const visible = ref(false);
const title = ref('');
const message = ref('');
const mode = ref('confirm'); // 'confirm' or 'info'
const yesText = ref('Ja');
const noText = ref('Nein');

let resolvePromise = null;

function open(opts = {}) {
    title.value = opts.title || '';
    message.value = opts.message || '';
    mode.value = opts.mode || 'confirm';
    yesText.value = opts.yesText || 'Ja';
    noText.value = opts.noText || 'Nein';
    visible.value = true;
    return new Promise(resolve => { resolvePromise = resolve; });
}

function accept() {
    visible.value = false;
    resolvePromise?.('accepted');
}

function deny() {
    visible.value = false;
    resolvePromise?.('denied');
}

defineExpose({ open });
</script>
